import { render, staticRenderFns } from "./MPagination.vue?vue&type=template&id=bf1d38f8"
import script from "./MPagination.vue?vue&type=script&lang=js"
export * from "./MPagination.vue?vue&type=script&lang=js"
import style0 from "./MPagination.vue?vue&type=style&index=0&id=bf1d38f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports